import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { interval } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';

import { selectUser } from '@core/store/auth/auth.selectors';
import { selectDataspaceModel } from '@core/store/dataspace/dataspace.selectors';
import { isNil } from '@core/utils/shared-utils';

@Component({
  selector: 'app-home',
  imports: [TranslateModule],
  templateUrl: 'home.component.html',
  styles: ``
})
export class HomeComponent {
  private readonly store = inject(Store);
  private readonly translate = inject(TranslateService);

  private readonly user = toSignal(this.store.select(selectUser));
  private readonly dataspace = toSignal(this.store.select(selectDataspaceModel));

  private readonly currentLang = toSignal(
    this.translate.onLangChange.pipe(
      filter((value) => !isNil(value)),
      map((value) => value.lang)
    ),
    { initialValue: this.translate.getCurrentLang() }
  );

  private readonly tick = toSignal(interval(60_000).pipe(startWith(0)), {
    initialValue: 0
  });

  protected readonly timestamp = computed(() => {
    this.tick();
    const now = new Date();
    const date = now.toLocaleDateString().slice(0, 10);
    const h = String(now.getHours()).padStart(2, '0');
    const m = String(now.getMinutes()).padStart(2, '0');
    return `${date} · ${h}:${m}`;
  });

  protected readonly greeting = computed(() => {
    this.currentLang();
    const name = this.user()?.firstName;
    const key = name ? 'home.greeting.hello' : 'home.greeting.hello_anonymous';
    return this.translate.instant(key, { name });
  });

  protected readonly dataspaceName = computed(() => this.dataspace()?.name ?? '');
}
